<template>
    <section class="textSection">
        <h1>Contacts</h1>
        <!-- Information de contact et map -->
        <div class="contact-info">
            <td><p>Pour toutes questions sur le MOOC et la formation, n'hésitez pas à nous contacter.</p>
        
                <p> Mail : <a href="mailto:contact@savoiretreaidant.fr">contact@savoiretreaidant.fr</a></p>
                <p> Plan d'accès des locaux : </p>
       
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2627.2451459685885!2d2.3916735160723412!3d48.81538387928334!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e6724cd11a08f1%3A0xe0f90bdc3866f4fa!2sSilver+Innov!5e0!3m2!1sfr!2sfr!4v1505943931734" width="600" height="450" frameborder="0" style="border:0" allowfullscreen></iframe></td>
        </div>
        <!-- Formulaire de contact -->
        <div class="contact-form">
            <p>Vous pouvez aussi nous écrire ci dessous</p>
            <form class="form-contact" v-on:submit.prevent="sendForm">

                <label for="contact-name">Nom</label>
                <input type="text" id="contact-name" placeholder="Votre nom" v-model="lastName">

                <label for="contact-prenom">Prénom</label>
                <input type="text" id="contact-prenom" placeholder="Votre prénom" v-model="firstName">

                <label for="contact-mail">Email *</label>
                <input type="email" id="contact-mail" placeholder="Email" required="required" v-model="email">

                <label for="contact-description">Votre demande *</label>
                <textarea id="contact-description" :style="[description.length > 1000 ? {'border-color' : 'red'} : '']" placeholder="Description de votre demande..." required="required" v-model="description"></textarea>

                <!-- Gestion de la taille de la description-->
                <p v-if="description.length > 1000" style="font-size:12px; font-weight: bold; color:red;">Vous ne pouvez pas dépasser les 1000 caractères.</p>
                <p v-else style="font-size:12px; font-weight: bold;">{{1000 - description.length}} caractères restants</p>
                <div class="g-recaptcha" data-sitekey="6LcK1bcUAAAAAMcGdzqHlk2n3OAHcyaxxI-5Ct3i"></div>
                <!-- Submit -->
                <button type="submit">Envoyer</button>

                <p style="font-weight: bold; font-size: 10px;">* obligatoire</p>
            </form>
        </div>
    </section>
</template>

<script>
    import UsersServices from '../services/users'

    export default {
        name: "contact",

        data: function() {
            return {
                lastName: '',
                firstName: '',
                email: '',
                description: '',
                error: false,
                submitted: false,
            }
        },

        methods: {
            sendForm: function () {
                UsersServices.contactMail({
                    lastName: this.lastName,
                    firstName: this.firstName,
                    email: this.email,
                    description: this.description
                }).then((res) => {
                    this.lastName = '';
                    this.firstName = '';
                    this.email = '';
                    this.description = '';
                    this.error = false;
                    this.submitted = true;
                }, (res) => {
                    this.submitted = false;
                })
            }
        }
    }
</script>

<style scoped>
    #g-recaptcha-response {
        display: block !important;
        position: absolute;
        margin: -78px 0 0 0 !important;
        width: 302px !important;
        height: 76px !important;
        z-index: -999999;
        opacity: 0;
    }

    td {
        margin-left: auto;
        margin-right : auto;
        text-align: center;
    }

    .contact-info {
        width: 55%;
        margin: 0;
        display: inline-block;
    }

    .contact-form {
        width: 35%;
        float: right;
        display: inline;
        text-align: start;
    }

    form {
        border: 1px solid darkgrey;
        border-radius: 4px;
        padding: 15px;
    }

    input, textarea {
        margin-top: 5px;
        margin-bottom: 10px;
        width: 90%;
        padding: 10px 5px;
        background-color: #fafafa;
        border-radius: 2px;
        font-size: 16px;
        -webkit-box-shadow: inset 0 1px 2px rgba(0,0,0,.4);
        box-shadow: inset 0 1px 2px rgba(0,0,0,.4);
        resize: none;
        display: block;
    }

    textarea {
        height: 80px;
    }

    input:focus, textarea:focus {
        outline: none;
    }

    label {
        font-weight: bold;
    }

    button {
        color: #fff;
        background-color: #0f3274;
        padding: 10px 12px;
        border: none;
        border-radius: 3px;
        cursor: pointer;
    }

</style>



// WEBPACK FOOTER //
// Contact.vue?7570dfc4